import dayjs from "dayjs";
import "dayjs/locale/tr";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);
